var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade-fast-kit"}},[(_vm.isLoadingDelayed)?_c('div',{class:_vm.$style.loader,style:({ width: `${this.size * 5}px`, height: `${this.size * 5}px` })},[_vm._t("icon")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }